var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/molecules/house-feature-list.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["house", "translations"], 
[], 
function (l_house, l_translations, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("house", l_house);
frame.set("translations", l_translations);
var t_2 = "";t_2 += "\n    ";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "templates/components/molecules/house-feature-list.html.njk", false, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
t_3.getExported(function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
context.setVariable("iconTemplate", t_3);
t_2 += "\n\n    <ul class=\"nh-list\">\n        ";
var t_6;
t_6 = true;
frame.set("petsNotAllowed", t_6, true);
if(frame.topLevel) {
context.setVariable("petsNotAllowed", t_6);
}
if(frame.topLevel) {
context.addExport("petsNotAllowed", t_6);
}
t_2 += "\n        ";
frame = frame.push();
var t_9 = runtime.memberLookup((l_house),"features");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("feature", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
t_2 += "\n            ";
var t_11;
t_11 = t_10;
frame.set("iconName", t_11, true);
if(frame.topLevel) {
context.setVariable("iconName", t_11);
}
if(frame.topLevel) {
context.addExport("iconName", t_11);
}
t_2 += "\n\n            ";
if(t_10 == "wifi") {
t_2 += "\n                ";
var t_12;
t_12 = "wifi";
frame.set("iconName", t_12, true);
if(frame.topLevel) {
context.setVariable("iconName", t_12);
}
if(frame.topLevel) {
context.addExport("iconName", t_12);
}
t_2 += "\n            ";
;
}
t_2 += "\n\n            ";
if(t_10 == "swimmingPool") {
t_2 += "\n                ";
var t_13;
t_13 = "swimming-pool";
frame.set("iconName", t_13, true);
if(frame.topLevel) {
context.setVariable("iconName", t_13);
}
if(frame.topLevel) {
context.addExport("iconName", t_13);
}
t_2 += "\n            ";
;
}
t_2 += "\n\n            ";
if(t_10 == "petsAllowed") {
t_2 += "\n                ";
var t_14;
t_14 = false;
frame.set("petsNotAllowed", t_14, true);
if(frame.topLevel) {
context.setVariable("petsNotAllowed", t_14);
}
if(frame.topLevel) {
context.addExport("petsNotAllowed", t_14);
}
t_2 += "\n                ";
var t_15;
t_15 = "pets";
frame.set("iconName", t_15, true);
if(frame.topLevel) {
context.setVariable("iconName", t_15);
}
if(frame.topLevel) {
context.addExport("iconName", t_15);
}
t_2 += "\n            ";
;
}
t_2 += "\n\n            ";
if(t_10 == "contactlessStay" || t_10 == "instantBooking") {
t_2 += "\n                ";
var t_16;
t_16 = null;
frame.set("iconName", t_16, true);
if(frame.topLevel) {
context.setVariable("iconName", t_16);
}
if(frame.topLevel) {
context.addExport("iconName", t_16);
}
t_2 += "\n            ";
;
}
t_2 += "\n\n            ";
if(!env.getTest("null").call(context, runtime.contextOrFrameLookup(context, frame, "iconName")) === true) {
t_2 += "\n                <li class=\"nh-list__item\">\n                    ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 27, colno = 42, runtime.callWrap(runtime.memberLookup((t_3),"render"), "iconTemplate[\"render\"]", context, [{"name": runtime.contextOrFrameLookup(context, frame, "iconName"),"size": "0.875"}]))), env.opts.autoescape);
t_2 += "\n                </li>\n            ";
;
}
t_2 += "\n        ";
;
}
}
frame = frame.pop();
t_2 += "\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "petsNotAllowed")) {
t_2 += "\n            <li class=\"nh-list__item\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 37, colno = 38, runtime.callWrap(runtime.memberLookup((t_3),"render"), "iconTemplate[\"render\"]", context, [{"name": "no-pets","size": "0.875","custom": true}]))), env.opts.autoescape);
t_2 += "\n            </li>\n        ";
;
}
t_2 += "\n\n        <li class=\"nh-list__item\">\n            <span class=\"card--house__people\">\n                ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_house),"persons"), env.opts.autoescape);
t_2 += "\n                ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_translations),"persons"), env.opts.autoescape);
t_2 += "\n            </span>\n        </li>\n\n        ";
if(runtime.memberLookup((l_house),"bedrooms") > 0) {
t_2 += "\n            <li class=\"nh-list__item\">\n                <span class=\"card--house__bedrooms\">\n                    ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_house),"bedrooms"), env.opts.autoescape);
t_2 += "\n                    ";
if(runtime.memberLookup((l_house),"bedrooms") == 1) {
t_2 += "\n                        ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_translations),"bedroom"), env.opts.autoescape);
t_2 += "\n                    ";
;
}
else {
t_2 += "\n                        ";
t_2 += runtime.suppressValue(runtime.memberLookup((l_translations),"bedrooms"), env.opts.autoescape);
t_2 += "\n                    ";
;
}
t_2 += "\n                </span>\n            </li>\n        ";
;
}
t_2 += "\n    </ul>\n";
})});
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/molecules/house-feature-list.html.njk"] , dependencies)